import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { useAuth, formatApiError } from "../context/AuthContext";
import { PrimaryBtn, Field, Input } from "../components/kit";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(email, password, name || "Golfer");
      navigate("/onboarding");
    } catch (err) {
      const msg = formatApiError(err.response?.data?.detail) || "Registration failed. Please try again.";
      setError(msg);
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10 justify-center">
          <Flag className="text-[#CCFF00]" size={28} />
          <span className="font-heading text-3xl">PAR<span className="text-[#CCFF00]">PREP</span></span>
        </div>
        <div className="border border-[#262626] bg-[#141414] p-8">
          <h1 className="font-heading text-2xl uppercase mb-1">Create account</h1>
          <p className="text-sm text-[#A3A3A3] mb-6">Build your junior golfer's tournament plan.</p>
          {error && (
            <div data-testid="register-error" className="mb-5 border border-[#FF3B30] bg-[#FF3B30]/10 text-[#FF3B30] text-sm px-4 py-3">
              {error}
              {/already registered/i.test(error) && (
                <> <Link to="/login" className="underline font-bold">Log in instead</Link>.</>
              )}
            </div>
          )}
          <form onSubmit={submit} className="space-y-5">
            <Field label="Your name">
              <Input data-testid="register-name" value={name}
                onChange={(e) => setName(e.target.value)} placeholder="Parent / player name" />
            </Field>
            <Field label="Email">
              <Input data-testid="register-email" type="email" value={email} required
                onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </Field>
            <Field label="Password">
              <Input data-testid="register-password" type="password" value={password} required minLength={6}
                onChange={(e) => setPassword(e.target.value)} placeholder="min 6 characters" />
            </Field>
            <PrimaryBtn data-testid="register-submit" type="submit" disabled={busy} className="w-full">
              {busy ? "Creating…" : "Create Account"}
            </PrimaryBtn>
          </form>
          <p className="mt-6 text-sm text-[#A3A3A3] text-center">
            Already have an account? <Link to="/login" className="text-[#CCFF00] hover:underline">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
